<template>
  <v-card flat class="pt-5">
    <v-list-item>
      <v-list-item-content two-line class="pt-0">
        <v-list-item-title class="headline">
          <template v-if="type === 'nouveau'">
            Saisie initiale de mot de passe
          </template>
          <template v-else>
            Réinitialisation du mot de passe
          </template>
        </v-list-item-title>
        <v-list-item-subtitle>
          <template v-if="type === 'nouveau'">
            Activation de l'accès agil après la création
          </template>
          <template v-else>
            Procédure de réinitilisation de mot de passe
          </template>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-card-text>
      <p>
        Vous devez saisir et confirmer un mot de passe pour l'utilisateur
        {{ login }}.
      </p>
      <p>
        Vous serez connecté à l'application après validation de votre mot de
        passe par le serveur.
      </p>
    </v-card-text>

    <v-card-text>
      <v-row dense>
        <v-col cols="12" md="6">
          <v-alert type="error" v-if="errorserver">
            <p>{{ errorserver }}.</p>
            <p>
              Le mot de passe n'a pas été mis à jour.
            </p>
          </v-alert>
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-text>
      <v-form v-model="valid" lazy-validation ref="form">
        <v-row dense>
          <v-col cols="12" md="6">
            <v-text-field
              label="Mot de passe"
              placeholder="Veuillez saisir votre mot de passe"
              v-model.trim="motdepasse"
              dense
              :disabled="loading"
              filled
              :rules="motdepasseRules"
              :error-count="4"
              :type="affichemotdepasse ? 'text' : 'password'"
              :append-icon="affichemotdepasse ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="affichemotdepasse = !affichemotdepasse"
            />
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="12" md="6">
            <v-text-field
              label="Confirmer mot de passe"
              placeholder="Veuillez confirmer votre mot de passe"
              v-model.trim="confirmation"
              dense
              :disabled="loading"
              filled
              :rules="[
                () =>
                  motdepasseIdentiques() ||
                  'Les mots de passes doivent être identiques',
              ]"
              :type="afficheconfirmation ? 'text' : 'password'"
              :append-icon="afficheconfirmation ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="afficheconfirmation = !afficheconfirmation"
            />
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-btn
        color="primary"
        :disabled="!valid"
        :loading="loading"
        @click="renouvelle"
        >Envoyer</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import ValidationRules from '@/plugins/mixins/ValidationRules';
import toasted from '@/utils/toasted';
import Api from '@/utils/api';
export default {
  mixins: [ValidationRules],
  props: {
    type: String,
    login: String,
    demande: String,
  },
  beforeRouteEnter: (to, from, next) => {
    new Api('/motdepasse/renouvellement', '/oauth')
      .get({
        params: {
          identifant: to.query.login,
          code: to.query.demande,
        },
      })
      .then(response => {
        if (!response.ok) {
          toasted.error('auth.renouvellementNonTrouve');
          next('/');
        } else {
          next();
        }
      })
      .catch(() => {
        next('/');
      });
  },
  data() {
    const majuscule = m => /[A-Z]/.test(m) || 'doit contenir une majuscule';
    const minuscule = m => /[a-z]/.test(m) || 'doit contenir une minuscule';
    const special = m => /\W/.test(m) || 'doit contenir un caractère spécial';
    const taille = m =>
      (m || '').length >= 8 || 'doit avoir au moins 8 caractères';
    return {
      valid: true,
      loading: false,
      motdepasse: null,
      confirmation: null,
      affichemotdepasse: false,
      afficheconfirmation: false,
      errorserver: null,
      motdepasseRules: [
        majuscule,
        minuscule,
        special,
        taille,
        this.obligatoireRule(),
      ],
    };
  },
  methods: {
    motdepasseIdentiques() {
      return this.motdepasse == this.confirmation;
    },
    renouvelle() {
      this.errorserver = null;
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.$api('/motdepasse/renouvellement', '/oauth')
          .post({
            motDePasse: this.motdepasse,
            identifant: this.login,
            code: this.demande,
          })
          .then(response => {
            if (response.ok) {
              toasted.info('auth.motDePasseChange', null, 5000);
              this.$router.push({ name: 'login' });
            }
          })
          .catch(error => {
            this.errorserver = error.error;
          })
          .finally(() => (this.loading = false));
      }
    },
  },
};
</script>
